import { render, staticRenderFns } from "./ElSelectRemoteEx.vue?vue&type=template&id=5b8bbf52&"
import script from "./ElSelectRemoteEx.vue?vue&type=script&lang=js&"
export * from "./ElSelectRemoteEx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports